<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import { computed, ref } from 'vue';

const props = defineProps({
  modelValue: { type: String, default: '' },
  options: { type: Array, default: () => [] },
});

const emit = defineEmits(['update:modelValue', 'select', 'clear', 'submit']);
const isOpen = ref(false);

const normalizedQuery = computed(() => props.modelValue.trim().toLowerCase());
const visibleOptions = computed(() => {
  if (!normalizedQuery.value) return props.options.slice(0, 5);

  return props.options
    .filter(option =>
      [option.label, option.email, option.phone]
        .filter(Boolean)
        .some(value =>
          String(value).toLowerCase().includes(normalizedQuery.value)
        )
    )
    .slice(0, 5);
});

const selectOption = option => {
  emit('update:modelValue', option.label);
  emit('select', option);
  isOpen.value = false;
};

const clearSearch = () => {
  emit('update:modelValue', '');
  emit('clear');
  isOpen.value = false;
};
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <div class="relative flex min-w-[240px] flex-[1.4] flex-col gap-1">
    <label
      class="text-[11px] font-semibold uppercase tracking-wide text-lais-text-muted"
    >
      Nome do cliente
    </label>
    <div
      class="flex h-10 items-center gap-2 rounded-lais border border-lais-border bg-white px-3 focus-within:border-lais-primary"
    >
      <span class="i-lucide-search size-4 text-lais-text-muted" />
      <input
        :value="modelValue"
        type="search"
        placeholder="Nome do cliente"
        class="min-w-0 flex-1 bg-transparent text-[14px] text-lais-text outline-none placeholder:text-lais-text-muted"
        @input="emit('update:modelValue', $event.target.value)"
        @focus="isOpen = true"
        @keydown.enter="
          isOpen = false;
          emit('submit');
        "
      />
      <button
        v-if="modelValue"
        type="button"
        class="grid size-6 place-items-center rounded-full text-lais-text-muted hover:bg-lais-bg-soft hover:text-lais-primary"
        aria-label="Limpar busca de cliente"
        @click="clearSearch"
      >
        <span class="i-lucide-x size-3.5" aria-hidden="true" />
      </button>
    </div>

    <div
      v-if="isOpen && visibleOptions.length"
      class="absolute left-0 right-0 top-[66px] z-20 overflow-hidden rounded-lais border border-lais-border bg-white shadow-lais-pop"
    >
      <button
        v-for="option in visibleOptions"
        :key="option.key"
        type="button"
        class="flex w-full items-center gap-3 px-3 py-2 text-left hover:bg-lais-bg-soft"
        @mousedown.prevent="selectOption(option)"
      >
        <span
          class="grid size-8 shrink-0 place-items-center rounded-full bg-lais-primary-50 text-[12px] font-semibold text-lais-primary"
        >
          {{ option.initials }}
        </span>
        <span class="min-w-0">
          <span class="block truncate text-[13px] font-semibold text-lais-text">
            {{ option.label }}
          </span>
          <span class="block truncate text-[12px] text-lais-text-muted">
            {{ option.phone || option.email || 'Cliente da proposta' }}
          </span>
        </span>
      </button>
    </div>
  </div>
</template>
